/* eslint-disable no-console */
import Vue from 'vue';

export default class Logger {
  get highestLogLevel() {
    const keys = Object.keys(this.logLevels);
    return this.logLevels[keys[keys.length - 1]];
  }

  get logLevels(): Record<string, number> {
    // This needs to be kept ordered in ascending order
    // order is indicative of importance
    return {
      debug: 0,
      info: 1,
      warning: 2,
      error: 3,
    };
  }
  get consoleLogLevel() {
    if (!Vue.$config.isLoaded) {
      return -1;
    }
    const logLevelSelected = Vue.$config.values['logging-to-console-level'];
    const usingOldConfigProp = logLevelSelected === undefined && Vue.$config.values['networking-write-to-console'];
    if (logLevelSelected === undefined || usingOldConfigProp) {
      return -1;
    }

    return this.logLevels[logLevelSelected.toLowerCase()];
  }

  /** Logs a debug message */
  debug(message?: any) {
    if (this.consoleLogLevel <= 0) { console.log(message); }
  }
  /** Logs an info message */
  info(message?: any) {
    if (this.consoleLogLevel <= 1) { console.info(message); }
  }
  /** Logs a warning message */
  warning(message?: any) {
    if (this.consoleLogLevel <= 2) { console.warn(message); }
  }
  /** Logs an error message */
  error(message?: any) {
    if (this.consoleLogLevel <= 3) { console.error(message); }
  }
}
